/**
 * MB-379 — lo que el paso de revisión de "Crear expediente" dice sobre la renovación,
 * o `null` si el expediente no es una renovación. El folio anterior es opcional: sin él
 * se dice explícitamente, para que la revisión no parezca incompleta.
 */
export const renewalReviewText = (
  isRenewal: boolean,
  previousFolio: string,
): string | null => {
  if (!isRenewal) return null;
  const folio = previousFolio.trim();
  return folio ? `Sí — folio anterior #${folio}` : "Sí — sin folio anterior";
};
